import { render, staticRenderFns } from "./fromComponents.vue?vue&type=template&id=355434b4&scoped=true&"
import script from "./fromComponents.vue?vue&type=script&lang=js&"
export * from "./fromComponents.vue?vue&type=script&lang=js&"
import style0 from "./fromComponents.vue?vue&type=style&index=0&id=355434b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355434b4",
  null
  
)

export default component.exports